import { Link } from "react-router-dom";
import { ArrowLeft, Ticket } from "lucide-react";
import { CodeForm } from "../components/site/DemandeBon";

export default function DemandeCode() {
  return (
    <div className="min-h-screen bg-pblv-bg" data-testid="demande-code-page">
      <header className="mx-auto flex max-w-2xl items-center justify-between px-6 py-5">
        <Link to="/" data-testid="code-back-home" className="inline-flex items-center gap-2 text-sm font-semibold text-pblv-mauve hover:underline">
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
        <img src="/logo-tpoz.png" alt="T'POZ" className="h-14 w-auto" />
      </header>

      <main className="mx-auto max-w-2xl px-6 pb-20">
        <div className="rounded-3xl border border-pblv-ink/10 bg-pblv-bg p-6 shadow-sm sm:p-10">
          <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-pblv-mauve/12 text-pblv-mauve">
            <Ticket className="h-6 w-6" strokeWidth={1.6} />
          </span>
          <h1 className="font-serif text-3xl font-medium text-pblv-ink sm:text-4xl">Obtenir mon code pour réserver</h1>
          <p className="mt-2 mb-6 text-sm leading-relaxed text-pblv-inksoft">
            Faites votre demande en quelques minutes. Après validation, vous recevrez votre code T'POZ par mail —
            valable pour 3 T'POZ par an.
          </p>
          <CodeForm />
        </div>
      </main>
    </div>
  );
}
